import React, { Component } from 'react';

class Source extends React.Component {

  render() {
    var name = this.props.name;
    var sources = this.props.sources;

    return(
      <div className="row mt-1 mb-1">
        <div className="col">
          <p><a href={sources[name].link} target="_blank">{sources[name].label}</a></p>
        </div>
      </div>
    )
  }
}

export default Source;
